import Component from 'vue-class-component'
import PreviewContainerVue from './PreviewContainer'
import { SectionData } from '../../store/editor/components/state'

@Component
export default class SectionVue extends PreviewContainerVue<SectionData> {

  get color(): string | undefined {
    const data = this.componentData
    return data.background ? data.background.color : undefined
  }
}
